import { gql } from '@redwoodjs/web'

const SIGNATURE_REQUEST_FIELDS = gql`
  fragment SignatureRequestFields on SignatureRequest {
    signatureRequestId
    createdAt
    status
    packageName
    documentNames
    sentAt
    completedAt
    lastSyncedAt
    signers {
      signatureRequestSignerId
      role
      name
      routingOrder
      status
    }
  }
`

export const GET_SIGNATURE_REQUESTS = gql`
  ${SIGNATURE_REQUEST_FIELDS}
  query GET_SIGNATURE_REQUESTS($applicantId: String!) {
    signatureRequests(applicantId: $applicantId) {
      ...SignatureRequestFields
    }
  }
`

export const REFRESH_SIGNATURE_REQUESTS = gql`
  ${SIGNATURE_REQUEST_FIELDS}
  mutation REFRESH_SIGNATURE_REQUESTS($applicantId: String!) {
    refreshSignatureRequests(applicantId: $applicantId) {
      ...SignatureRequestFields
    }
  }
`
